import { Component, OnInit } from '@angular/core';
import { JeevesInvoiceListConfigService } from 'gung-standard-jeeves';

@Component({
    selector: 'ref-ref-jeeves-invoice-list',
    template: '<lib-filter-list [configService]="configService"></lib-filter-list>',
    standalone: false
})
export class RefJeevesInvoiceListComponent implements OnInit {
  constructor(public configService: JeevesInvoiceListConfigService) {}

  ngOnInit() {}
}
